import { createFileRoute, redirect } from '@tanstack/react-router'
import { ConsolidatedHoldingsPage } from '../pages/ConsolidatedHoldingsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/consolidated-holdings' as any)({
    component: ConsolidatedHoldingsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})

